import User from "../../components/User/User";
import { buyerSubRoles } from "../../config/ROLES";

export default function BuyerUser() {

  return (
    <User subRoles={buyerSubRoles} />
  );
}